import { FieldArray } from 'react-final-form-arrays';
import styles from './FounderDetails.module.scss';
import { Field, useForm } from 'react-final-form';
import dayjs from 'dayjs';
import OutlinedFormInput from '../../Finance/components/OutlinedFormInput/OutlinedFormInput';
import MeritoDateField from '../../Finance/components/DateField/MeritoDateField';
import { useState } from 'react';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { RiAddFill as AddIcon } from 'react-icons/ri'
import { founderIntialState } from '../context/UnderwritingFormContext';
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { directorFields } from './directorHelper';

type Props = {
    handleAddFounderScroll: (divId: string) => void;
}

const getDirectorFieldValidator = (key: string) => directorFields.find((field) => field.key == key)?.validatorFunc;

const FounderDetails = ({ handleAddFounderScroll }: Props) => {
    const { mutators: { remove } } = useForm();
    const [toBeRemovedIndex, setToBeRemovedIndex] = useState(null);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    return (
        <>
            <FieldArray name="directors">
                {({ fields }) => {
                    return (
                        <>
                            {fields.map((fieldName, index) => {
                                return (
                                    <div key={fieldName}>
                                        <div id={`director_${index}`} className={styles.founderFieldsRootContainer}>
                                            {fields.length > 1 ? <div className={styles.founderHeaderContainer}>
                                                <div className={styles.founderTitle}>
                                                    Director {index + 1}
                                                </div>
                                                <div className={styles.btnContainer}>
                                                    <MeritoButton icon={<DeleteIcon />} type='destructive-ghost' size='md2' onClick={() => {
                                                        setToBeRemovedIndex(index);
                                                        setShowDeleteConfirmation(true);
                                                    }} />
                                                </div>
                                            </div> : null}
                                            <div className={styles.founderDetailsRootContainer}>
                                                <Field validate={getDirectorFieldValidator('name')} name={`${fieldName}.name`}>
                                                    {(props) => (
                                                        <OutlinedFormInput
                                                            {...props.input}
                                                            name={props.input.name}
                                                            maxLength={100}
                                                            value={props.input.value}
                                                            onChange={props.input.onChange}
                                                            label="Director's Name"
                                                            placeholder='John Doe'
                                                            error={props.meta.error}
                                                            touched={props.meta.touched}
                                                            fieldType='lg'
                                                        />
                                                    )}
                                                </Field>
                                                <Field validate={getDirectorFieldValidator('pan')} name={`${fieldName}.pan`}>
                                                    {(props) => (
                                                        <OutlinedFormInput
                                                            {...props.input}
                                                            name={props.input.name}
                                                            maxLength={10}
                                                            allUpercase={true}
                                                            value={props.input.value}
                                                            onChange={props.input.onChange}
                                                            label="PAN"
                                                            placeholder='ABCDE1234F'
                                                            error={props.meta.error}
                                                            touched={props.meta.touched}
                                                            fieldType='lg'
                                                        />
                                                    )}
                                                </Field>
                                                <Field validate={getDirectorFieldValidator('dob')} name={`${fieldName}.dob`}>
                                                    {(props) => (
                                                        <MeritoDateField
                                                            {...props.input}
                                                            label="Date of Birth"
                                                            name={props.input.name}
                                                            onChange={props.input.onChange}
                                                            error={props.meta.error}
                                                            value={props.input.value}
                                                            touched={props.meta.touched}
                                                            format={"DD/MM/YYYY"}
                                                            showIcon={false}
                                                            size="md2"
                                                            minDate={dayjs().subtract(100, 'year')}
                                                            maxDate={dayjs()}
                                                        />
                                                    )}
                                                </Field>
                                                <Field validate={getDirectorFieldValidator('address')} name={`${fieldName}.address`}>
                                                    {(props) => (
                                                        <OutlinedFormInput
                                                            {...props.input}
                                                            name={props.input.name}
                                                            maxLength={500}
                                                            value={props.input.value}
                                                            onChange={props.input.onChange}
                                                            label="Address"
                                                            placeholder='102, Acme Building, BKC, Mumbai, 400060.'
                                                            error={props.meta.error}
                                                            touched={props.meta.touched}
                                                            isTextArea={true}
                                                            maxRows={3}
                                                            fieldType='lg'
                                                        />
                                                    )}
                                                </Field>
                                            </div>
                                        </div>
                                        {index != fields.length - 1 ? <div className={styles.separator}></div> : null}
                                    </div>
                                )
                            })}

                            <div className={styles.addBtnActionContainer}>
                                <div>
                                    <MeritoButton size='md2' type='secondary-1' icon={<AddIcon />} btnText={"Add Another Director"} onClick={() => {
                                        const currentLength = fields.length;
                                        fields.push(founderIntialState);
                                        setTimeout(() => {
                                            handleAddFounderScroll(`director_${currentLength}`)
                                        }, 100);
                                    }} />
                                </div>
                            </div>
                        </>
                    )
                }}
            </FieldArray>

            <ConfirmDialog
                modalStyles={{ maxWidth: '450px' }}
                showButton={false}
                visible={showDeleteConfirmation}
                toggle={() => {
                    setShowDeleteConfirmation(!showDeleteConfirmation);
                }}
                showCloseBtn={false}
                size={"md"}
            >
                <div className={styles.confirmationContainer}>
                    <div className={styles.topContainer}>
                        <div className={styles.iconContainer}>
                            <Exclamation />
                        </div>
                        <div className={styles.title}>
                            Are You Sure You Want to Delete This Director?
                            <br />
                            <br />
                        </div>
                    </div>
                    <div className={styles.bottomContainer}>
                        <MeritoButton onClick={() => {
                            setShowDeleteConfirmation(false);
                        }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Cancel'} />
                        <MeritoButton size="lg" onClick={() => {
                            remove('directors', toBeRemovedIndex)
                            setShowDeleteConfirmation(false);
                        }} isRounded={true} btnType="button" type="primary-1" btnText="Delete" />
                    </div>
                </div>
            </ConfirmDialog>
        </>
    );
}

export default FounderDetails;
